<template>
    <a class="news-link" :href="path">
        <div class="title f-toe2">{{item.title}}</div>
        <ul class="img-list">
            <li
                v-for="(img, index) in images"
                :key="index"
                :class="['img-item', `img-${index + 1}`]"
            >
                <div :class="{'img-wrap': true}">
                    <div class="img" :data-src="img"></div>
                </div>
            </li>
        </ul>
        <div class="info f-toe1">
            <span class="catg f-toe1" v-if="item.category">{{item.category}}</span
            ><span class="source f-toe2" v-if="item.source">{{item.source}}</span
            ><span class="time">{{timestamp | dateFormat2}}</span>
        </div>
    </a>
</template>

<script>
import {artTypes, inApp} from 'common/constant';
import newsItemMixin from 'common/mixin/news-item';
import Jt from 'common/util/jt';

export default {
    mixins: [newsItemMixin],
    props: {
        item: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {
        images() {
            const imgUrl = this.item.imgUrl;
            const images = imgUrl ? imgUrl.split(',http') : [];
            for(let i = 1; i < images.length; i++) {
                images[i] = 'http' + images[i];
            }
            return images.slice(0, 3);
        }
    },
    methods: {
    }
}
</script>

<style lang="less" scoped>
.title {
    margin-bottom: 0.08rem;
    line-height: 1.5;
    color: rgba(0, 0, 0, 1);
    font-size: 0.13rem;
}
.img-list {
    display: flex;
    margin-bottom: 0.08rem;
    .img-item {
        flex: 1;
    }
    .img-1, .img-2 {
        margin-right: 0.02rem;
    }
    .img-wrap {
        position: relative;
        padding-bottom: 71.43%;
        // background: url('../../image/placeholder.png') center center no-repeat;
        background-color: #f6f6f6;
        background-size: contain;
        &.en {
            // background-image: url('../../image/placeholder_en.png');
        }
    }
    .img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: center center no-repeat;
        background-size: 100% 100%;
    }
}
.info {
    color: rgba(0, 0, 0, 0.3);
    font-size: 0.11rem;
    line-height: 0.14rem;
    .catg, .source {
        max-width: 1rem;
        margin-right: 0.06rem;
    }
    span {
        display: inline-block;
        vertical-align: middle;
        &:last-child {
            margin-right: 0;
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/common/component/news-stream/news-tpl-3.vue